<template>
  <div>
    <v-combobox
        v-model="textValue"
        :label="label"
        :items="items"
        :return-object="false"
        hide-no-data
        :class="{ 'search-warning': isValueError }"
        :error="isValueError"
        :error-messages="errorMessages"
        small-chips
        :clearable="true"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import {
  FETCH_EMT_LIST,
} from '@/store/IncidentView/actions';

export default {
  name: 'TeamMember',
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
    },
    clientId: {
      type: Number,
    },
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      isValueError: false,
    };
  },

  computed: {
    textValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.isValueError = false;

        // Handle for the case clearable is true.
        if (newValue === null) {
          this.$emit('input', '');
          return;
        }

        let val = newValue.trim();
        if (newValue.trim().length > 8) {
          val = newValue.trim().substring(0, 8);
          this.isValueError = true;
        }
        this.$emit('input', val);
      },
    },
    errorMessages() {
      if (this.isValueError) {
        return this.$t('incidentView.teamMember.searchWarning');
      }
      return '';
    },
  },
  async mounted() {
    if (this.clientId) {
      this.items = await this.fetchEmtList(this.clientId);
    }
  },
  methods: {
    ...mapActions({
      fetchEmtList: `incidentView/${FETCH_EMT_LIST}`,
    }),
  },
};
</script>

<style scoped>
.search-warning >>> .v-input__control > .v-text-field__details {
  margin-top: -5px;
}
</style>
